{
  "longPressMessage": "Πατήστε παρατεταμένα για να ανοίξετε την προεπισκόπηση"
}
